import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as LeafA } from "../../assets/ecoscore/LeafA.svg";
import { ReactComponent as LeafB } from "../../assets/ecoscore/LeafB.svg";
import { ReactComponent as LeafC } from "../../assets/ecoscore/LeafC.svg";
import { ReactComponent as LeafD } from "../../assets/ecoscore/LeafD.svg";
import { ReactComponent as LeafE } from "../../assets/ecoscore/LeafE.svg";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import NavbarLeft from "../Components/NavbarLeft";
import ScoreCircle from "../Components/ScoreCircle";

const ReduceScenarios = () => {
  return (
    <>
      <NavbarLeft currentPage={3} />
      <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start ml-[25px]">
        <div className="w-full relative left-[70px] flex justify-start items-center">
          <Link to="/Reduce">
            <BackArrow />
          </Link>
          <p className="font-Poppins-SemiBold text-lg relative p-10">
            Réduire - Optimisation #1
          </p>
        </div>
      </div>
      <div className="mt-[70px] ml-[70px] h-[747px] w-[1370px] flex items-center justify-center">
        <div className="w-[1200px] h-[550px]">
          <div className="w-full h-[500px] rounded-lg shadow">
            <div className="bg-[#BEC4C] h-[50px] rounded-t-lg flex justify-between font-Poppins-SemiBold text-sm items-center ml-[40px] mr-[60px]">
              <div>Solution d'optimisation</div>
              <div>Eco-score</div>
              <div>Score EF</div>
              <div>Solution optimale</div>
              <div>Solution unique</div>
              <div>Actions</div>
            </div>
            <Link to={"/ReduceAnalysis"}>
            <div className="bg-white w-full">
              <div className="h-[50px] flex justify-left items-center mx-[40px]">
                <div className="w-[255px] h-full flex items-center">name</div>
                <div className="w-[195px] h-[50px] flex items-center">
                  <LeafA height={40} />
                </div>
                <div className="w-[200px]">
                  <div className="w-[45px] h-[45px]">
                    <ScoreCircle score={82} />
                  </div>
                </div>
                <div className="w-[225px] h-[50]">
                  <Checked />
                </div>
                <div className="w-[165px]">
                  <Checked />
                </div>
                <div>
                  <div class="flex item-center justify-center">
                    <div class="w-4 mr-2 transform hover:text-purple-500 hover:scale-110">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    </div>
                    <div class="w-4 mr-2 transform hover:text-purple-500 hover:scale-110">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                        />
                      </svg>
                    </div>
                    <div class="w-4 mr-2 transform hover:text-purple-500 hover:scale-110">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </Link>
            <Link to={"/ReduceParametersChoice"}>
            <div className="bg-[#BEC4C] w-full">
              <div className="h-[50px] flex justify-left items-center mx-[40px]">
                <div className="w-[255px] h-full flex items-center">name</div>
                <div className="w-[195px] h-[50px] flex items-center">
                  <LeafA height={40} />
                </div>
                <div className="w-[200px]">
                  <div className="w-[45px] h-[45px]">
                    <ScoreCircle score={82} />
                  </div>
                </div>
                <div className="w-[225px] h-[50]">
                  <Checked />
                </div>
                <div className="w-[165px]">
                  <Checked />
                </div>
                <div>
                  <div class="flex item-center justify-center">
                    <div class="w-4 mr-2 transform hover:text-purple-500 hover:scale-110">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    </div>
                    <div class="w-4 mr-2 transform hover:text-purple-500 hover:scale-110">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                        />
                      </svg>
                    </div>
                    <div class="w-4 mr-2 transform hover:text-purple-500 hover:scale-110">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReduceScenarios;
